//交差監視用オプション（テンプレート）
export let observerTplOptions = {
  root: null,
  rootMargin: "-50% 0%",
  threshold: 0,
};
